import $ from 'jquery';

$(function () {
  var $tierToUpdate;
  var $newReward;
  var tiers = ['low', 'mid', 'high'];

  var getOldRewardIds = function (tier) {
    return $('.js-reward-id.' + tier).val();
  };

  var updateSaveButton = function ($reward) {
    var tier = $reward.data('tier');
    var newRewardId = $reward.data('new-id');
    var oldRewardId = getOldRewardIds(tier);
    $('.reward-change-option').hide();
    if (newRewardId == oldRewardId) {
      $('#reward-change-cancel').show();
    } else if ($('#is-onboarding').val() == 'true') {
      $('#reward-save-without-warning').show();
    } else {
      $('#reward-save-with-warning').show();
    }
  };

  var activateCurrentRewards = function () {
    $('.js-new-reward').removeClass('active');
    tiers.forEach(function (tier) {
      $('.js-new-reward[data-new-id="' + getOldRewardIds(tier) + '"]').addClass(
        'active',
      );
    });
  };

  activateCurrentRewards();

  $('#reward-save-with-warning').on('click', function () {
    $('#reward-save-with-warning').hide();
    $('#reward-change-warning').show();
  });

  $('.js-open-library').on('click', function () {
    $('.js-new-reward').show();
    activateCurrentRewards();
    var tier = $(this).data('tier');
    updateSaveButton($('.js-new-reward.active[data-tier="' + tier + '"]'));
    $('.js-new-reward:not([data-tier="' + tier + '"])').hide();

    var tierSelector = '.js-' + tier;
    $tierToUpdate = $(tierSelector);
    $('#js-library').modal('show');
  });

  $('.js-new-reward').on('click', function () {
    $newReward = $(this);
    var tier = $newReward.data('tier');
    updateSaveButton($newReward);
    $('.js-new-reward[data-tier="' + tier + '"]').removeClass('active');
    $newReward.toggleClass('active');
  });

  $('.js-set-new-reward').on('click', function (e) {
    e.preventDefault();
    $tierToUpdate
      .find('.js-reward-image')
      .attr('src', $newReward.children('.js-new-image').attr('src'));
    $tierToUpdate
      .find('.js-reward-caption')
      .text($newReward.children('.js-new-caption').text());
    $tierToUpdate.find('.js-reward-id').val($newReward.data('new-id'));

    $('#js-library').modal('hide');
  });
});
